import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "layoutruleoptions"
    }}>{`LayoutRuleOptions`}</h1>
    <p>{`Options for setting the layout rule on a page.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`OFF`}</strong>{` = 1330005536`}</p>
      <p parentName="blockquote">{`No layout rule on the page as it resizes.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`SCALE`}</strong>{` = 1280332643`}</p>
      <p parentName="blockquote">{`Scale objects on the page as it resizes.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`RECENTER`}</strong>{` = 1280332387`}</p>
      <p parentName="blockquote">{`Recenter objects on the page as it resizes.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`GUIDE_BASED`}</strong>{` = 1280329538`}</p>
      <p parentName="blockquote">{`Use guide slicing to resize objects on the page as it resizes.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`OBJECT_BASED`}</strong>{` = 1280331586`}</p>
      <p parentName="blockquote">{`Reposition and resize objects on the page as it resizes.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`USE_MASTER`}</strong>{` = 1280333133`}</p>
      <p parentName="blockquote">{`Use layout rule from the page's applied master page.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`PRESERVE_EXISTING`}</strong>{` = 1280331890`}</p>
      <p parentName="blockquote">{`Use existing layout rule setting on the page. Used for creating alternate layouts.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      